(() => {
  if (customElements.get('auvenne-delivery-estimate')) return;
  class AuvenneDeliveryEstimate extends HTMLElement {
    connectedCallback() {
      const output = this.querySelector('[data-auv-delivery-output]');
      const minimum = Number(this.dataset.minDays);
      const maximum = Number(this.dataset.maxDays);
      if (!output || !Number.isInteger(minimum) || !Number.isInteger(maximum)) return;
      const addBusinessDays = (value) => {
        const date = new Date();
        date.setHours(12, 0, 0, 0);
        let remaining = value;
        while (remaining > 0) {
          date.setDate(date.getDate() + 1);
          if (date.getDay() !== 0 && date.getDay() !== 6) remaining -= 1;
        }
        return date;
      };
      const locale = this.dataset.locale === 'sv' ? 'sv-SE' : this.dataset.locale === 'en' ? 'en-GB' : 'nl-NL';
      const format = new Intl.DateTimeFormat(locale, { weekday: 'short', day: 'numeric', month: 'long' });
      const prefix = this.dataset.prefix || '';
      const connector = this.dataset.connector || ' – ';
      const suffix = this.dataset.suffix || '';
      output.textContent = prefix + format.format(addBusinessDays(minimum)) + connector + format.format(addBusinessDays(maximum)) + suffix;
    }
  }
  customElements.define('auvenne-delivery-estimate', AuvenneDeliveryEstimate);
})();
